import {Pipe, PipeTransform} from '@angular/core';
import {GradeMap, GRADES_LIST} from '@app/core/model/grade.map';

@Pipe({
    name: 'ngcGradeMap'
})
export class GradeMapPipe implements PipeTransform {

    private gradeSortPositions = {};

    constructor() {
        GRADES_LIST.forEach((item: {id; name}, index: number) => {
            this.gradeSortPositions[item.id.toLowerCase()] = index;
        });
    }

    transform(value: any, args?: any): any {
        if (value && Array.isArray(value)) {
            value.sort((a: string, b: string) => {
                const aGrade = (a || '').toLowerCase();
                const bGrade = (b || '').toLowerCase();
                const diff = this.getGradePosition(aGrade) - this.getGradePosition(bGrade);
                return diff === 0 ? aGrade.localeCompare(bGrade) : diff;
            });

            return value.map((grade: string) => this.getGradeTitle(grade));
        } else {
            return this.getGradeTitle(value);
        }
    }

    getGradeTitle(value: string): string {
        return (value && GradeMap.has(value)) ? GradeMap.get(value) : value;
    }

    private getGradePosition(grade: string): number {
        return this.gradeSortPositions.hasOwnProperty(grade) ? this.gradeSortPositions[grade] : 1000;
    }
}
